/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateDto } from './RealEstateDto';
import {
    RealEstateDtoFromJSON,
    RealEstateDtoFromJSONTyped,
    RealEstateDtoToJSON,
    RealEstateDtoToJSONTyped,
} from './RealEstateDto';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';

/**
 * 
 * @export
 * @interface GetRgiRiskResponse
 */
export interface GetRgiRiskResponse {
    /**
     * 
     * @type {string}
     * @memberof GetRgiRiskResponse
     */
    type: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof GetRgiRiskResponse
     */
    person?: PersonDto;
    /**
     * 
     * @type {RealEstateDto}
     * @memberof GetRgiRiskResponse
     */
    realEstate?: RealEstateDto;
    /**
     * 
     * @type {Date}
     * @memberof GetRgiRiskResponse
     */
    contractStartDate?: Date;
}

/**
 * Check if a given object implements the GetRgiRiskResponse interface.
 */
export function instanceOfGetRgiRiskResponse(value: object): value is GetRgiRiskResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetRgiRiskResponseFromJSON(json: any): GetRgiRiskResponse {
    return GetRgiRiskResponseFromJSONTyped(json, false);
}

export function GetRgiRiskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRgiRiskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'person': json['person'] == null ? undefined : PersonDtoFromJSON(json['person']),
        'realEstate': json['realEstate'] == null ? undefined : RealEstateDtoFromJSON(json['realEstate']),
        'contractStartDate': json['contractStartDate'] == null ? undefined : (new Date(json['contractStartDate'])),
    };
}

export function GetRgiRiskResponseToJSON(json: any): GetRgiRiskResponse {
    return GetRgiRiskResponseToJSONTyped(json, false);
}

export function GetRgiRiskResponseToJSONTyped(value?: GetRgiRiskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'person': PersonDtoToJSON(value['person']),
        'realEstate': RealEstateDtoToJSON(value['realEstate']),
        'contractStartDate': value['contractStartDate'] == null ? undefined : ((value['contractStartDate']).toISOString().substring(0,10)),
    };
}

